export default {
    state: {
        account: {
            headers: [
                { text: 'Description', align: 'center', sortable: false, value: 'description' },
                { text: 'ID', align: 'center', sortable: false, value: 'id' },
                { text: 'Status', align: 'center', sortable: false, value: 'status' },
                { text: 'Type', align: 'center', sortable: false, value: 'type' },
                { text: 'Actions', align: 'center', sortable: false, value: 'actions' },
            ],
            edit: [],
            types: [],
            statuses: [],
        },
        editAccount: [],

    },
    getters: {
        getAccountTypes: (state) =>{
            var list = [];
            for (var i=0; i<state.account.types.length; i++) {
                list.push(state.account.types[i]);
            }
            console.log("account types list", list);
            return list;
        },
        getAccountStatuses: (state) =>{
            var list = [];
            for (var i=0; i<state.account.statuses.length; i++) {
                list.push(state.account.statuses[i]);
            }
            console.log("account statuses list", list);
            return list;
        },
        getAccountStatusById: (state) => (id) => {
            var status = state.account.statuses.find(status => status.id == id);
            // console.log("getAccountStatusById, id, status", id, status);
            return status.name;
        },
        getAccountTypeById: (state) => (id) => {
            var type = state.account.types.find(type => type.id == id);
            return type.name;
        }

    },
    mutations: {
        editAccount (state, data){
            state.editAccount = data
        },
        setAccountTypes (state, data){
            state.account.types = data
        },
        setAccountStatuses (state, data){
            state.account.statuses = data
        },
    },
    actions: {
        editAccount({commit}, data){
            commit('editAccount', data)
        },
        setAccountTypes({commit}, data){
            commit('setAccountTypes', data)
        },
        setAccountStatuses({commit}, data){
            commit('setAccountStatuses', data)
        },
    }
}
